import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    const target = this.hasModalTarget ? this.modalTarget : this.element
    if (target) {
      target.style.display = "none"
    }

    const blink = this.element.querySelector("#blink")

    if (blink) {
      this.blinkTimer = setInterval(() => {
        blink.style.opacity = blink.style.opacity === "0" ? 1 : 0
      }, 1000)
    }

    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    if (this.blinkTimer) {
      clearInterval(this.blinkTimer)
      this.blinkTimer = null
    }

    document.removeEventListener("keydown", this.onKeydown)
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
    }

    const target = this.hasModalTarget ? this.modalTarget : this.element
    if (!target) return
    target.style.display = target.style.display === "none" ? "flex" : "none"
  }

  destroy(event) {
    if (event) {
      event.preventDefault()
    }

    const target = this.hasModalTarget ? this.modalTarget : this.element
    if (target) {
      target.style.display = "none"
    }
  }

  onKeydown(event) {
    const target = this.hasModalTarget ? this.modalTarget : this.element
    if (event.key === "Escape" && target && target.style.display !== "none") {
      this.destroy()
    }
  }
}
